<template>
  <div class="staffNo">
    <Navbar title="绑定员工号" :default-bg="false" :service="true"/>
    <div class="cart-box">
      <div class="cart">
        <div class="describe">
          <input type="text" placeholder="请输入姓名" v-model="name"
                 @input="changeInputVal($event,/[^a-z0-9A-Z\u4e00-\u9fa5]+/g,'name',0,6)"/>
        </div>
        <div class="describe">
          <input type="text" placeholder="请输入员工号" v-model="userNo"
                 @input="changeInputVal($event,/[^a-z0-9A-Z]+/g,'userNo',0,10)"/>
        </div>
      </div>
    </div>
    <div class="btn">
      <button class="themeColor" @click="bindEmployee">确定</button>
    </div>
  </div>
</template>

<script>
import Navbar from "../../components/NavBar";
import {Dialog, Toast} from "vant";

export default {
  name: "bindStaffNo",
  components: {Navbar},
  data() {
    return {
      userNo: '',
      name: ''
    }
  },
  methods: {
    changeInputVal(e, reg, key, min = 0, max) {
      this[key] = e.target.value.replace(reg, '').slice(min, max);
    },
    bindEmployee() {
      if (!this.name) {
        return Toast('请输入姓名');
      }
      if (!this.userNo) {
        return Toast('请输入员工号');
      }
      this.$post('user/bindEmployee', {userNo: this.userNo, name: this.name}).then(res => {
        if (res.status == 200) {
          Dialog.alert({
            message: "绑定成功，请重新登录",
            confirmButtonColor: '#126AFC',
          }).then(() => {
            localStorage.removeItem('user_token');
            localStorage.removeItem('user_type');
            this.$router.replace('/login');
          })
        } else {
          Toast.fail(res.msg);
        }
      })
    }
  }
}
</script>

<style scoped lang="less">
.staffNo {
  font-size: 15px;

  .cart-box {
    padding: 0 15px;
    box-sizing: border-box;
    margin-top: 20px;

    .cart {
      background: #FFFFFF;
      padding: 0 20px;
      box-sizing: border-box;
      border-radius: 8px;

      .describe:last-child {
        border-bottom: none;
      }

      .describe {
        height: 50px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        border-bottom: 1px solid #EEEEEE;

        input {
          border: none;
          flex: 1;
        }

        button {
          background: transparent;
          color: #126AFC;
          border: none;
        }
      }
    }
  }

  .btn {
    padding: 0 15px;
    box-sizing: border-box;
    margin-top: 70px;

    button {
      width: 100%;
      height: 50px;
      border: none;
      border-radius: 25px;
      font-size: 18px;
      font-weight: bold;
    }
  }
}
</style>